function ErrorMessage(props) {
    return (
        <div className='mt2 mb1 tc dark-red f6'>
            {props.children}
        </div>
    )
}

export default ErrorMessage;